/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import ReactDOM from "react-dom/client";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import { BrowserRouter } from 'react-router-dom';
import Feature from './feature-module/feature';
import 'aos/dist/aos.css';
import '../src/style/icons/fontawesome/css/all.min.css';
import { Provider } from 'react-redux';
import store from './core/data/redux/store';
import '../src/style/icons/feather/css/iconfont.css'
import '../src/style/scss/main.scss'
import '../src/style/css/feather.css'
import './../src/index.css'
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { base_path } from "./environment";


const persistor = persistStore(store);
const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter basename={base_path}>
        <Feature />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
   
  );
} else {
  console.error("Element with id 'root' not found.");
}
